import {State} from '../state';
import {createSelector, MemoizedSelector} from '@ngrx/store';
import {selectBpmnModelerState} from "./bpmn-modeler-state.selector";

const getExplorerViewCommand = (state: State): any => state.explorerViewCommand;

export const selectExplorerViewCommand: MemoizedSelector<object, object> = createSelector(selectBpmnModelerState, getExplorerViewCommand);
